export enum RiskRegisterDisplayRowKind {
    Seg = "seg",
    GroupHeader = "group-header",
}
